export * from './collection-type-toggle.shared.component';
export * from './collection-type-toggle.shared.module';
